
import 	BlockEdit from './edit';

const { registerBlockType }     =   wp.blocks;
const { withSelect, select }    =   wp.data;

registerBlockType('diviner-blocks/carousel', {
    title: 'Carousel',
    description: 'Insert a Carousel using Images from Gallery',
    category: 'diviner-blocks',
    icon: {
        src: 'image-flip-horizontal',
        foreground: '#1d7eb6'
    },

    attributes: {
	    clientId: {
		    type: 'string',
		    default: '',
	    },
        mediaId: {
	        type: 'array',
	        default: [],
        },
        speed: {
	        type: 'number',
	        default: 2
        },
        loop: {
	        type: 'boolean',
	        default: false
        },
        controls: {
	        type: 'boolean',
	        default: false
        },
        pager: {
	        type: 'boolean',
	        default: false
        }
    },
    
    supports: {
	    align: ['center', 'wide', 'full']
    },

    edit: withSelect((select, props) => {
	    
	    let IDs = props.attributes.mediaId
	    
	    let media = []
	    
	    if ( IDs.length == 0 ) {
		    media = undefined
	    } else {
			media = select('core').getMediaItems({ include: IDs })
	    }
		
		return { media }
		
	})(BlockEdit),

    save: (props) => { return null }
});
